import { ReportListItemData } from './report-base';

export class FinancialsReportUserListItem extends ReportListItemData {
  feeName: string;
  originalAmount: number;
  scholarshipAmount: number;
  creditAmount: number;
  discountAmount: number;
  paid: number;
  pastDue: number;
  refunds: number;
  removedDate: Date;

  getBalance() {
    return this.originalAmount - this.paid - this.discountAmount - this.scholarshipAmount - this.creditAmount + this.refunds;
  }

  get exportData() {
    return {
      Members: `${this.firstName} ${this.lastName}`,
      Team: this.teamGroup,
      Fee: this.feeName,
      'Original Fee': this.originalAmount,
      Discount: this.discountAmount,
      Scholarship: this.scholarshipAmount,
      Credit: this.creditAmount,
      Refund: this.refunds,
      Paid: this.paid,
      'Past Due': this.pastDue,
      Balance: this.getBalance(),
    };
  }
}

export class FinancialsReport {
  pastDuePlayers: number;
  currentPlayers: number;
  list: FinancialsReportUserListItem[];

  constructor(data: any = {}) {
    this.currentPlayers = +data.currentPlayers;
    this.pastDuePlayers = +data.pastDuePlayers;
    this.list = data.financialsReportUserList ? data.financialsReportUserList.map(l => new FinancialsReportUserListItem(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/financials-report.ts